
import React, {useEffect,useState} from 'react';
// import Pagination from "react-js-pagination";
import Pagination from '../Share/Pagination'
import Cookies from "universal-cookie";
import axios from "axios";
import Host, { FrontEndDomain } from "../../../assets/js/Host";
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import SurveyForm from './SurveyForm';
import SurveyView from './SurveyView';
import StyledDataGrid from '../GeneralComponents/StyledDataGrid'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {useSelector,useDispatch} from 'react-redux'
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import Grid from '../Share/Grid'
import {useTranslation} from "react-i18next";

const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language")?cookies.get("language"):"ar"
function Surveys() {
    const directions = useSelector(state => state.settingsData.directions)
    const MainTheme = useSelector(state => state.settingsData.MainTheme)
    const [t, i18n] = useTranslation('common');


    const [loading, setloading] = useState(false);
    const [state, setData] = useState({
        surveys: ''
    });
    const [rows,setRows]=useState([])
    const [surveysToatal,setSurveysTotal]=useState(0)
    const [pageSize,setPageSize]=useState(5)
    const [pageNumber,setPageNumber]=useState(1)
    const [SurveysNumberOfPage,setSurveyNumberOfPage]=useState(0)
    const [showSurveyForm, setshowSurveyForm] = useState(false);
    const [showSurveyView, setshowSurveyView] = useState(false);
    const [selectedSurvey, setselectedSurvey] = useState(null);
   
    const columns = [
        { field: 'id', headerName: t('SURVEY.ID'), flex: .1 },
        {
            field: 'name', headerName: t('SURVEY.NAME'), flex: 2,
            renderCell: (rows) => (
                <div style={{ width: '100%' }} className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    {rows.row?.name}
                </div>
            )
        },
        {
            field: 'point_status', headerName: t('SURVEY.POINT_STATUS'), flex: 2,
            renderCell: (rows) => (
                <div style={{ width: '100%' }} className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    {rows?.row?.point_type?.name}
                </div>
            )
        },
        {
            field: 'point_name', headerName: t('SURVEY.POINT_NAME'), flex: 1.5,
            renderCell: (rows) => (
                <div style={{ width: '100%', }} className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    {rows.row?.point?.name}
                </div>
            )
        },
        {
            field: 'actions', flex: 1,
            headerName: t('SURVEY.ACTIONS'),
            renderCell: (rows) => (
                <strong className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    <IconButton
                        size="small"
                        style={{ marginLeft: 0 }}
                        onClick={() => {
                            viewObject(rows.row)
                        }}>
                        <Tooltip title={directions=='rtl' ?'عرض':"View"}>
                            <RemoveRedEyeIcon style={{ fill: "#111827" }} />
                        </Tooltip>
                    </IconButton>

                  

                    <IconButton
                        style={{ marginLeft: 15 }}
                        aria-label="view"
                        size="small"
                        onClick={() => {
                            updateObject(rows.row)
                            // previewObject(rows.row.object1)
                        }}>
                        <Tooltip title={directions=='rtl' ?'تعديل':"edit"}>
                            <EditIcon style={{ fill: "#111827" }} />
                        </Tooltip>
                    </IconButton>

                    <IconButton
                        style={{ marginLeft: 15 }}
                        aria-label="view"
                        size="small"
                        onClick={() => {
                            deleteObject(rows.row)
                        }}>
                        <Tooltip title={directions=='rtl' ?'حذف':"delete"}>
                            <DeleteIcon style={{ fill: "#f00" }} />
                        </Tooltip>
                    </IconButton>

                    <IconButton
                        style={{ marginLeft: 15 }}
                        aria-label="view"
                        size="small"
                        onClick={() => {
                            window.open(FrontEndDomain + `build_survey?id=${rows?.row?.id}`, '_blank')

                            // previewObject(rows.row.object1)
                        }}>
                        <Tooltip title={directions=='rtl' ?'بناء':"build"}>
                            <BuildCircleIcon style={{ fill: "#111827" }} />
                        </Tooltip>
                    </IconButton>
                </strong>
            ),
        },
    ]


    const fetchData = async (pageNumber = 1) => {
        setloading(true)
        try {
            const result=await axios({
                url: Host + "surveys?page="+pageNumber,
                method: "get",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                const surveys=result.data ;
                
                console.log(surveys);
                setData({
                    surveys:surveys 
                });
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
                   
    };
    const updateObject = async (object) => {
      
        setselectedSurvey(object)
        setshowSurveyForm(true)
    };
    
    
    const deleteObject = async (object) => {
        if (!window.confirm("Delete the item?")) {
            return
        }
        setloading(true)
        try {
            const result=await axios({
                url: Host + "surveys/"+object.id,
                method: "delete",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                toast.error(result.data.data)
                fetchData();
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
    };
  
    const createObject = async (object) => {
        setselectedSurvey(null)
        setshowSurveyForm(true)
    };
    const buildObject = async (object) => {
        setselectedSurvey(null)
        setshowSurveyForm(true)
    };

   
    const handleSetshowSurveyForm = (openStatus,needsReload) => {
      if(needsReload)
      fetchData();
      setshowSurveyForm(openStatus)
    };

    const handleSetshowSurveyView = (openStatus,needsReload) => {
        if(needsReload)
            fetchData();
        setshowSurveyView(openStatus)
    };

    const viewObject = async (object) => {
        setselectedSurvey(object)
        console.log(showSurveyView);
        setshowSurveyView(true)
    }
   
    const handlePageChange = (newPage) => {
        setPageNumber(newPage + 1)
    }

    useEffect(() => {        
        fetchData(pageNumber);
    }, [pageNumber])

    useEffect(() => {
        if (state && state.surveys&&state.surveys?.data?.length > 0) {
            setRows(state?.surveys?.data);
            setSurveysTotal(state?.surveys?.total)
            setSurveyNumberOfPage(state?.surveys?.last_page)
        }
    }, [state])

    const checkDarknessOrLightnessForColor=(color)=>{
        // Variables for red, green, blue values
        var r, g, b, hsp;
      
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
    
            // If RGB --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            
            r = color[1];
            g = color[2];
            b = color[3];
        } 
        else {
            
            // If hex --> Convert it to RGB: http://gist.github.com/983661
            color = +("0x" + color.slice(1).replace( 
            color.length < 5 && /./g, '$&$&'));
    
            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }
        
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
        );
    
        // Using the HSP value, determine whether the color is light or dark
        if (hsp>127.5) {
    
            return false;//light
        } 
        else {
    
            return true;//dark
        }
  
    };

    const check=checkDarknessOrLightnessForColor(MainTheme?.paperTextColor)
    

    const styleTextField={
        backgroundColor:!check?'rgb(255,255,255,0.7)':'rgb(0,0,0,0.4)',
        color:MainTheme?.paperTextColor,
    }

    const styleSelect={
        backgroundColor:!check?'rgb(255,255,255,0.7)':'rgb(0,0,0,0.4)',
        color:MainTheme?.paperTextColor,
    }

    // useEffect(() => {
    //     fetchData();
    // }, [])
    
    return (
        <>
            {showSurveyForm?
                <SurveyForm survey={selectedSurvey} showSurveyForm={showSurveyForm} setshowSurveyForm={handleSetshowSurveyForm} />
            :null}
            {showSurveyView?
                <SurveyView survey={selectedSurvey} color={MainTheme?.paperTextColor} bgCOlor={!checkDarknessOrLightnessForColor(MainTheme?.paperTextColor)?'rgb(255,255,255,0.7)':'rgb(0,0,0,0.4)'}   styleSurvey={styleTextField} showSurveyView={showSurveyView} setshowSurveyView={handleSetshowSurveyView} />
            :null}
          

            <Grid
              rows={rows}
              columns={columns}
              rowTotals={surveysToatal}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              loading={loading}
              handlePageChange={handlePageChange}
              NumberOfPage={SurveysNumberOfPage}
              directions={directions}
              hasCreate={true}
              createObject={createObject}
              title={t('SURVEY.HEADER_TITLE')}
            //   title_ar="قائمة الاستبيانات"
              gridHeight={{
                height:rows?.length>5?pageSize==5?400:pageSize==10?650:950:400,
              }}
            />

        </>
    );
}

export default Surveys;




{/* <div className="container">
<div className="row justify-content-center">
    <div className="col-md-12">
        <div className="card">
            <div className="card-header">Survey List<Button style={{float:'right'}} onClick={()=>{createObject()}}>create</Button></div>
            <div className="card-body">
            <table>
                <thead>
                    <tr>
                        <th>1</th>
                        <th>Name</th>
                        <th>Point Status</th>
                        <th>Point Name</th>
                        <th>View</th>
                        <th>Build</th>
                        <th>edit</th>
                        <th>delete</th>
                    </tr>
                </thead>
                <tbody>
                {   
                    state?.surveys?.data ? 
                        state?.surveys?.data?.map((object) => (
                                <tr key={object?.id}>
                                    <td>{object?.id}</td>
                                    <td>{object?.name}</td>
                                    
                                    <td>{object?.point_type?.name}</td>
                                    <td>{object?.point?.name}</td>
                                    <td><Button onClick={()=>{viewObject(object)}}>View</Button></td>
                                    <td><Button onClick={()=>{updateObject(object)}}>update</Button></td>
                                    <td><Button style={{backgroundColor:'red',color:'white'}} onClick={()=>{deleteObject(object)}}>delete</Button></td>
                                    <td><Button onClick={()=>{
                                        
                                        window.open(FrontEndDomain + `build_survey?id=${object?.id}`, '_blank')
                                    }}>Build</Button></td>
                                </tr>
                        )) : "Loading..."
                }
                </tbody>
            </table>
                <div>
                    <Pagination
                        activePage={state?.surveys?.current_page ? state?.surveys?.current_page : 0}
                        itemsCountPerPage={state?.surveys?.per_page ? state?.surveys?.per_page : 0 }
                        totalItemsCount={state?.surveys?.total ? state?.surveys?.total : 0}
                        onChange={(pageNumber) => {
                            fetchData(pageNumber)
                        }}
                        pageRangeDisplayed={8}
                        itemClass="page-item"
                        linkClass="page-link"
                        firstPageText="First Page"
                        lastPageText="Last Lage"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
</div> */}